import type { Translate } from '../../i18n';

/**
 * A contract's kind, in the reader's language.
 *
 * ⚠️⚠️ **ONE `t()` PER BRANCH WITH A LITERAL KEY** — the i18n rule. A computed
 * `` t(`contract.type.${type}`) `` cannot be checked against the catalogue's own key type, which
 * is exactly what catches a kind the product gains later and nobody translates.
 *
 * ⚠️ **Shared because two screens name the same thing** — the resource row's summary pop-over and
 * the project dashboard's contract picker (round 5 items 28 and 12). A second copy is how one of
 * them ends up not knowing about a third kind.
 *
 * ⚠️ **Falls back to the raw value rather than to an empty string.** An untranslated kind is a
 * missing translation, which is worth seeing; a blank reads as a contract that has no kind.
 */
export function contractTypeLabel(t: Translate, type: string | null): string {
  if (type === 'recurring') return t('contract.type.recurring');
  if (type === 'milestone') return t('contract.type.milestone');
  if (type === 'service') return t('contract.type.service');
  return type ?? '';
}
